import Vue from 'vue';
import Router from 'vue-router';

import Index from '@/components/dashboard/Index'
import PhoneNumber from '@/components/dashboard/PhoneNumber'
import UserAgreement from '@/components/dashboard/UserAgreement'
import EnterPhoneNumber from '@/components/dashboard/EnterPhoneNumber'
import SignIn from '@/components/dashboard/SignIn'
import Done from '@/components/dashboard/Done'
import ErrorCatchAll from '@/components/dashboard/ErrorCatchAll'
import ErrorMfaNotSet from '@/components/dashboard/ErrorMfaNotSet'
import ErrorWorkplaceNotInvited from '@/components/dashboard/ErrorWorkplaceNotInvited'
import ErrorAlreadyInvited from '@/components/dashboard/ErrorAlreadyInvited'
import ErrorNotProvisioned from '@/components/dashboard/ErrorNotProvisioned'
import ErrorOUCNotEligible from '@/components/dashboard/ErrorOUCNotEligible'
import Help from '@/components/dashboard/Help'
import Help25849 from '@/components/help/25849'
import Help25850 from '@/components/help/25850'
import Help25852 from '@/components/help/25852'
import Help25853 from '@/components/help/25853'
import Help25858 from '@/components/help/25858'
import Help25921 from '@/components/help/25921'
import HelpSecurity from '@/components/help/security'
import Help25862 from '@/components/help/25862'
import HelpPrivacy from '@/components/help/privacy'
import HelpFaqs from '@/components/help/faqs'

import authentication from '../authentication'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/user-agreement-notice',
      name: 'User Agreement Notice',
      component: UserAgreement
    },
    {
      path: '/user-agreement-notice-list',
      name: 'StaticUserAgreementNotice',
      component: UserAgreement
    },
    {
      path: '/phone-number',
      name: 'Phone Number',
      component: PhoneNumber
    },
    {
      path: '/enter-phone-number',
      name: 'Enter Phone Number',
      component: EnterPhoneNumber
    },
    {
      path: '/sign-in',
      name: 'Sign In',
      component: SignIn,
      meta: {
          requiresAuthentication: true
      }
    },
    {
      path: '/done',
      name: 'Done',
      component: Done
    },
    {
      path: '/error-catch-all',
      name: 'Error Catch All',
      component: ErrorCatchAll
    },
    {
      path: '/error-mfa-not-set',
      name: 'Error MFA Not Set',
      component: ErrorMfaNotSet
    },
    {
      path: '/error-wp-not-invited',
      name: 'Error Workplace Not Invited',
      component: ErrorWorkplaceNotInvited
    },
    {
      path: '/already-invited',
      name: 'Already Invited',
      component: ErrorAlreadyInvited
    },
    {
      path: '/not-provisioned',
      name: 'Not Provisioned',
      component: ErrorNotProvisioned
    },
    {
      path: '/ouc-not-eligible',
      name: 'OUC Not Eligible',
      component: ErrorOUCNotEligible
    },
    {
      path: '/help',
      name: 'Help',
      component: Help
    },
    {
      path: '/help-25849',
      name: 'Workplace on Android',
      component: Help25849
    },
    {
      path: '/help-25850',
      name: 'Workplace Chat on Android',
      component: Help25850
    },
    {
      path: '/help-25852',
      name: 'Workplace on iOS',
      component: Help25852
    },
    {
      path: '/help-25853',
      name: 'Workplace Chat on iOS',
      component: Help25853
    },
    {
      path: '/help-25858',
      name: 'Workplace on BT Webtop Phone 8 or 10 or a personal PC',
      component: Help25858
    },
    {
      path: '/help-25921',
      name: 'Workplace on a BT Webtop PC',
      component: Help25921
    },
    {
      path: '/help-security',
      name: 'Secure your account',
      component: HelpSecurity
    },
    {
      path: '/help-25862',
      name: 'How To fix Multi Factor Authentication issues',
      component: Help25862
    },
    {
      path: '/help-privacy',
      name: 'Data sharing and your right to object',
      component: HelpPrivacy
    },
    {
      path: '/faqs',
      name: 'Why Workplace by Facebook',
      component: HelpFaqs
    },
    {
      // Make sure this stays last on the list
      path: '*',
      redirect: '/'
    }
  ]
});


// Global route guard
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    // this route requires auth, check if logged in
    if (authentication.isAuthenticated()) {
      // only proceed if authenticated.
      next();
    } else {
      authentication.signIn();
    }
  } else {
    next();
  }
});

export default router;